import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import moment from 'moment'
import { filter } from 'lodash'

import withLoading from '../../components/withLoading'

import GridSelector from './DocumentGridSelector'

const query = gql`
  query documents($where: JSON!) {
    documents(where: $where) {
      id
      cod
      type
      due_date
    }
  }
`
const withQuery = graphql(query, {
  options: ({ customer_id, insurer_id }) => ({
    variables: { where: { customer_id, insurer_id, type: 'PROPOSAL' } }
  }),
  props: ({ data, ownProps }) => {
    console.log(data)
    if (data.documents) {
      const documents = filter(data.documents, doc =>
        moment(doc.due_date).isSameOrBefore(ownProps.due_date)
      )
      return { data: { ...data, documents } }
    }
    return { data }
  }
})

export default compose(
  withQuery,
  withLoading
)(GridSelector)
